package com.anjuros.website.redesign.sections.faq

import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.templates.selection.modules.BlogCard

/**
 * One topic on the FAQ page: its questions and answers, and links to the pages that cover it in more depth.
 * [shortTitle] is used where space is tight, like the topic buttons.
 */
class FaqTopic(
    val id: String,
    val title: RdText,
    val faqs: List<Pair<RdText, RdText>>,
    val links: List<Pair<RdText, String>>,
    val shortTitle: RdText = title,
)

val FaqTopics = listOf(
    FaqTopic(
        "getting-started", RdText.FAQS_TOPIC_START,
        listOf(
            RdText.FAQS_Q1 to RdText.FAQS_A1,
            RdText.FAQS_Q2 to RdText.FAQS_A2,
            RdText.FAQS_Q3 to RdText.FAQS_A3,
            RdText.FAQS_Q4 to RdText.FAQS_A4,
        ),
        listOf(RdText.FAQS_LINK_TRADES to RdRoute.TRADES),
    ),
    FaqTopic(
        "your-website", RdText.FAQS_TOPIC_WEBSITE,
        listOf(
            RdText.FAQS_Q5 to RdText.FAQS_A5,
            RdText.FAQS_Q6 to RdText.FAQS_A6,
            RdText.FAQS_Q7 to RdText.FAQS_A7,
            RdText.FAQS_Q8 to RdText.FAQS_A8,
        ),
        listOf(RdText.FAQS_LINK_DESIGNS to RdRoute.DESIGNS, RdText.FAQS_LINK_WHY_WEBSITE to BlogCard.BLOG1.pathToArticle),
    ),
    FaqTopic(
        "google-seo", RdText.FAQS_TOPIC_SEO,
        listOf(
            RdText.FAQS_Q9 to RdText.FAQS_A9,
            RdText.FAQS_Q10 to RdText.FAQS_A10,
        ),
        listOf(RdText.FAQS_LINK_SEO to RdRoute.SEO),
    ),
    FaqTopic(
        "enquiries-portal", RdText.FAQS_TOPIC_ENQUIRIES,
        listOf(
            RdText.FAQS_Q11 to RdText.FAQS_A11,
            RdText.FAQS_Q12 to RdText.FAQS_A12,
            RdText.FAQS_Q13 to RdText.FAQS_A13,
        ),
        listOf(RdText.FAQS_LINK_FORMS to RdRoute.CONTACT_FORMS, RdText.FAQS_LINK_PORTAL to RdRoute.PORTAL),
        shortTitle = RdText.FAQS_TOPIC_ENQUIRIES_SHORT,
    ),
    FaqTopic(
        "plans", RdText.FAQS_TOPIC_PLANS,
        listOf(RdText.FAQS_Q14 to RdText.FAQS_A14),
        listOf(RdText.FAQS_LINK_PRICING to RdRoute.PRICING),
    ),
)
